import {setupI18n} from '@lingui/core';

import {store} from './configureStore';
import memoize from 'lodash/memoize';

// load language strings
const getI18n = memoize(
  () => {
    let getStore = store.getState();
    let useLang = getStore.appSettings.language;
    let catalog = getStore.appSettings.catalog;
    let getStrs = setupI18n({
      language: useLang,
      catalogs: {[useLang]: catalog},
    });

    return getStrs;
  },
  () => store.getState().appSettings.language
);

export {getI18n};
//
